import request from '@/utils/request'

export function ready(item) {
  let data = Object.assign({}, item)
  return request({
    url: '/user/ready',
    data: data,
    method: 'post'
  })
}

export function active(item) {
  let data = Object.assign({}, item)
  return request({
    url: '/user/active',
    data: data,
    method: 'post'
  })
}

export function update(item) {
  let data = Object.assign({}, item)
  if (!data.password) {
    delete data.password
  }
  return request({
    url: '/user' + (data.id ? '/' + data.id : ''),
    data: data,
    method: 'post'
  })
}

export function remove(id) {
  return request({
    url: '/user/' + id,
    method: 'delete'
  })
}

export function search(form, skip) {
  return request({
    url: '/user',
    params: {
      q: form.q,
      skip: skip ? skip : 0,
    },
    method: 'get'
  })
}

